import React from 'react';

const Footer = () => {
    return(
        <footer className="footer">
            <div className="container">
                <div className="text-center">
                    Copyright © 2021 Equipment Hailing App
                </div>
            </div>
        </footer>
    )
};


export default Footer;